'use client'

import { isNil } from 'lodash-es'
import { useState } from 'react'

import { ResetPassword } from '@/features/reset-password'

import { Certification } from './certification'
import { useValidateCertNum } from '../api/validate-cert-num'

export const ResetPasswordPage = () => {
  const [certNum, setCertNum] = useState<string>()

  const validateCertNum = useValidateCertNum({
    onSuccess: certNum => {
      setCertNum(certNum)
    },
  })

  const isIdentityVerified = !isNil(certNum)

  const handleCertificationSuccess = (certNum: string) => {
    validateCertNum.execute({ certNum })
  }

  if (!isIdentityVerified) {
    return <Certification onCertificationSuccess={handleCertificationSuccess} />
  }

  return <ResetPassword certNum={certNum} />
}
